import * as React from "react";
import { Form, Formik, ErrorMessage } from "formik";
import { Input, Button } from "antd";
import { myFirebase } from "../components/authProvider";
import * as Yup from "yup";
import { showNotification } from "../utils";

export default function ForgotPassword(props) {
  const EmailValidation = Yup.object({
    email: Yup.string()
      .email("Invalid email")
      .ensure()
      .required("Required")
  });

  const initiatePasswordRecovery = (values, { resetForm, setStatus } ) => {
    console.log(values);
    setStatus("");
    myFirebase
      .auth()
      .sendPasswordResetEmail(values.email.trim())
      .then(async res => {
        console.log("res", res);
        // Email sent.
        console.log("Successfull");
        props.history.push("/");
        showNotification("success", "Success!", "Password reset email sent. Please check your email");
      })
      .catch(function(error) {
        // An error happened.
        console.log("Error", error);
        var errorCode = error.code;
        var errorMessage = error.message;
        if (errorCode === 'auth/user-not-found') {
          resetForm();
          setStatus('Email not registered yet. Please register first');
        }
        else  {
          resetForm();
          setStatus(errorMessage);
        }
      });
  };

  return (
    
    <div className="p-8 md:p-16 mx-auto">
      <br/>
      <Formik
        initialValues={{
          email: ""
        }}
        validationSchema={EmailValidation}
        onSubmit={initiatePasswordRecovery}
        enableReinitialize={true}
      >
        {({ values, errors, touched, handleChange, handleBlur, status, isSubmitting }) => (
          <Form>
            <div className="flex flex-col">
              <label className="text-sm text-gray-700 font-semibold">Registered email address</label>
              <Input
                size="large"
                type="text"
                placeholder="Enter your email"
                name="email"
                className={
                  errors.email && touched.email ? "border-red-500" : "border-gray-400" 
                }
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
                
              />
            </div>
            <div
              style={{
                minHeight: 21
              }}
            >
              <ErrorMessage
                name="email"
                component="div"
                className="text-red-500"
              />
            </div>
            <div className="md:flex my-8 space-y-4 md:space-y-0 md:space-x-4 text-center md:justify-center">
              <Button
                size="middle"
                type="primary"
                className="bg-purple-700 hover:bg-purple-600 border-none h-10 md:w-64"
                shape="round"
                block={true}
                htmlType="submit"
                loading={isSubmitting}
              >
                Reset password
              </Button>
              <Button
                size="middle"
                type="default"
                className="bg-indigo-200 md:bg-indigo-300 hover:bg-indigo-100 md:hover:bg-indigo-200 text-gray-700 border-none shadow-md h-10 md:w-64"
                shape="round"
                block={true}
                onClick={() => {
                  props.history.push("/");
                }}
              >
                Cancel
              </Button>
            </div>
            <div
              style={{
                minHeight: 21
              }}
            >
              {!!status && <p className="text-red-500">{status}</p>}
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
